import SyncEmailConfigManager from "./manager";


export {
  SyncEmailConfigManager,
}
